
const ValidatePassword = (password) => {
    return password.length >= 8;
};

export default ValidatePassword